import React, { useEffect, useState } from "react";
import Button from "../../designComponents/Button";
import Table from "../../designComponents/Table";
import Input from "../../designComponents/Input";
import { ReactComponent as SearchSVG } from "../../assets/icons/search.svg";
import { ButtonTab } from "../../designComponents/ButtonTab";
import Pagination from "../../components/Pagination";
import { useNavigate } from "react-router-dom";
import { JOBS_DETAILS_ROUTE } from "../../routes/routePaths";
import { SearchInputWrapperStyled } from "../Users/style";
import requestAPI from "../../utils/requestAPI";
import jobs from "../../apiConfigs/jobs";

type Props = {};
const cardData = [
  {
    title: "All",
    key: "all",
  },
  {
    title: "Active",
    key: "active",
  },
  {
    title: "Closed",
    key: "closed",
  },
];

const Jobs = (props: Props) => {
  const navigate = useNavigate();
  const [cardKey, setCardKey] = useState<string>("all");
  const [jobsData, setJobsData] = useState([]);

  const getAllJobs = async () => {
    try {
      const response = await requestAPI(jobs.getJobs());
      setJobsData(response.data);
    } catch (error) {
      console.error(error);
    }
  };


  useEffect(() => {
    getAllJobs();
  }, []);
  const handleClick = (key: string) => {
    setCardKey(key);
  };
  const userTabs = (
    <ButtonTab
      items={cardData}
      activeIndex={cardData.findIndex((x) => x.key === cardKey)}
      setActiveIndex={(index) => handleClick(cardData[index].key)}
    />
  );
  const [search, setSearch] = useState("");
  const tableData = {
    headings: [
      { key: "title", label: "Job Title" },
      { key: "priceType", label: "Price Type" },
      { key: "createdBy", label: "Job Created By" },
      { key: "role", label: "Role" },
      { key: "status", label: "Status" },
      { key: "actions", label: "Actions" },
    ],
    body: [
      {
        id: "",

        title: "Electric Repair",
        priceType: "Hourly",
        createdBy: "Nitish Landlord",
        role: "Tenant",
        status: "Active",
        actions: (
          <div
            style={{
              display: "flex",
              gap: "4px",
              justifyContent: "flex-end",
            }}
          >
            <Button
              variant="gray"
              radius="normal"
              onClick={() => {
                navigate(JOBS_DETAILS_ROUTE);
              }}
            >
              View
            </Button>
          </div>
        ),
      },
    ],
  };
  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "25px",
        }}
      >
        <div>
          <SearchInputWrapperStyled>
            <Input
              value={search}
              name="users"
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Search Jobs"
              iconLeft={<SearchSVG />}
            />
          </SearchInputWrapperStyled>
        </div>
      </div>

      <Table
        tableData={tableData}
        customRow={userTabs}
        // isLoading={isLoading}
        noData="No data to display."
        headingBgColor="#f0f0f0"
        showMenuIcon={false}
        evenRowBgColor="#fafafa"
      />
      <Pagination
        activePage={1}
        totalPages={10}
        limit={10}
        onCurrentPageChange={() => {}}
      />
    </div>
  );
};

export default Jobs;
